import { auth } from '../config/firebase';

/**
 * Extracts domain name from user's email for display purposes
 * Capitalizes first letter of domain name (e.g., "company.com" -> "Company")
 */
export const getDomainNameFromEmail = (email?: string): string => {
  if (!email) return 'Company';
  
  const domain = email.split('@')[1];
  return domain.split('.')[0].charAt(0).toUpperCase() + domain.split('.')[0].slice(1);
};

/**
 * Gets the current authenticated user's domain name for display
 */
export const getCurrentUserDomainName = (): string => {
  const user = auth.currentUser;
  return getDomainNameFromEmail(user?.email || undefined);
};

/**
 * Extracts domain from email and formats it for Firebase Storage path
 * Replaces dots with underscores for path compatibility (e.g., "company.com" -> "company_com")
 */
export const getStorageDomainPath = (email: string): string => {
  const fullDomain = email.split('@')[1];
  // Take only the last two parts (e.g., mail.company.com → company.com)
  const domainParts = fullDomain.split('.');
  const lastTwoParts = domainParts.slice(-2).join('.');
  const safeDomain = lastTwoParts.replace('.', '_');
  
  return safeDomain;
};

/**
 * Gets the current authenticated user's storage domain path
 */
export const getCurrentUserStoragePath = (): string => {
  const user = auth.currentUser;
  if (!user || !user.email) {
    throw new Error('User must be authenticated with email to access files');
  }
  
  return getStorageDomainPath(user.email);
};
